<template>
  <ul-page fullBody class="course-file" v-loading="loading">
    <template v-slot:left>
      <div class="page-header-right">
        <span class="title">教学资料</span>
      </div>
    </template>
    <template v-slot:right>
      <div class="page-header-right">
        <ul-button v-show="!teachFlag" @click="close">关闭</ul-button>
        <ul-button v-show="teachFlag" @click="look">返回</ul-button>
      </div>
    </template>
    <div class="body-content" ref="bodyContent">
      <div class="info" v-show="!teachFlag">
        您可以根据班级教学的安排，个性化的定义课程内容。您可以隐藏和显示课程内容、为内容添加“备注，点击添加新模块”、“添加单元”和“添加活动”可以自定义课程结构和内容。
      </div>
      <div class="screen">
        <div class="textbookList" v-show="!teachFlag">
          <span class="tit">课件：</span>
          <div>
            <span v-for="item in textbookList" :key="item.textbookId" :class="{'activate': item.textbookId == textbook.textbookId}" @click="clickTextbook(item,1)">{{ item.name }}</span>
          </div>
        </div>
        <div v-show="!teachFlag">
          <span class="tit">资源类型：</span>
          <div>
            <span v-for="item in typeList" :key="item.name" :class="{'activate': item.type == type}" @click="clickTextbook(item,2)">{{ item.name }}</span>
          </div>
        </div>
        <div v-show="teachFlag">
          <span class="tit">资源类型：</span>
          <div>
            <span v-for="item in teachTypeList" :key="item.name" :class="{'activate': item.type == teachType}" @click="clickTeachType(item)">{{ item.name }}</span>
          </div>
        </div>
      </div>
      <div class="textbook" v-show="!teachFlag">
        <div class="top">
          <span class="name">{{ textbook.name }}  教学资料</span>
          <ul-button type="primary" @click="downloadFile">下载全部资料</ul-button>
        </div>
        <ul-table :data="textbookResList">
          <ul-table-column label="文件名" width="380">
            <template slot-scope="scope">
              <div @click="preview(scope.row)" class="location">
                <i class="iconfont" :class="[fileIcon(scope.row.location)]"></i>
                <span>{{ scope.row.title }}</span>
              </div>
            </template>
          </ul-table-column>
          <ul-table-column label="大小">
            <template slot-scope="scope">
              <span class="bch-benone">{{ formatSize(scope.row.contentSize) }}</span>
            </template>
          </ul-table-column>
          <ul-table-column label="下载次数" prop="downloadCount">
          </ul-table-column>
          <ul-table-column label="操作">
            <template slot-scope="scope">
              <ul-button type="text" @click="download(scope.row)">下载</ul-button>
            </template>
          </ul-table-column>
        </ul-table>
        <ul-pagination
          class="pagination"
          hide-on-single-page
          @current-change="handleCurrentChange1"
          layout="prev, pager, next"
          prevText="上一页"
          nextText="下一页"
          :total="total1">
        </ul-pagination>
      </div>
      <div class="common-res">
        <div class="top" v-show="!teachFlag">
          <span>公共资源</span>
          <span class="look" @click="look">查看全部</span>
        </div>
        <ul-table :data="resList">
          <ul-table-column label="文件名" width="380">
            <template slot-scope="scope">
              <div @click="preview(scope.row)" class="location">
                <i class="iconfont" :class="[fileIcon(scope.row.location)]"></i>
                <span>{{ scope.row.title }}</span>
              </div>
            </template>
          </ul-table-column>
          <ul-table-column label="大小">
            <template slot-scope="scope">
              <span class="bch-benone">{{ formatSize(scope.row.contentSize) }}</span>
            </template>
          </ul-table-column>
          <ul-table-column label="下载次数" prop="downloadCount">
          </ul-table-column>
          <ul-table-column label="操作">
            <template slot-scope="scope">
              <ul-button type="text" @click="download(scope.row)">下载</ul-button>
            </template>
          </ul-table-column>
        </ul-table>
      </div>
      <ul-pagination
        class="pagination"
        hide-on-single-page
        v-show="teachFlag"
        @current-change="handleCurrentChange"
        layout="prev, pager, next"
        prevText="上一页"
        nextText="下一页"
        :total="total">
      </ul-pagination>
    </div>
    <ResourcePreview
      :resource="currentFile"
      v-if="isResourcePriviewVisible"
      @hide="isResourcePriviewVisible = false"
    ></ResourcePreview>
  </ul-page>
</template>

<script>
import Obs from "@/plugins/ulearning-obs.js";
import { teaResPublic, teachingResources, getTextbookList } from '@/api/courseApi'
import { fileIcon, formatSize, fileType, getFullPath } from "@/utils/file.js";
import { API_HOST, COURSE_API_HOST } from "@/config";
import ResourcePreview from "pc/components/resourcePreview.vue";
import { mapGetters } from 'vuex'
import { setObsConfig } from '@/utils/file.js'
export default {
  name: 'teaCourseFile',
  data () {
    return {
      ocId: this.$route.query.ocId,
      textbookId: this.$route.query.textbookId,
      textbookList: [],
      textbookResList: [],
      textbook: {},
      typeList: [
        {type: null,name:'全部'},
        {type: 2,name:'文档'},
        {type: 3,name:'图片'},
        {type: 4,name:'视频'},
        {type: 5,name:'音频'},
        {type: 6,name:'压缩包'}
      ],
      teachTypeList: [
        {type: null,name:'全部'},
        {type: 2,name:'文档'},
        {type: 3,name:'图片'},
        {type: 4,name:'视频'},
        {type: 5,name:'音频'},
        {type: 6,name:'压缩包'}
      ],
      resList: [],
      type: null,
      teachType: null,
      pn: 1,
      pn1: 1,
      total1: 0,
      total: 0,
      teachFlag: false,
      loading: true,
      isResourcePriviewVisible: false,
      currentFile: {}
    }
  },
  created () {
    this.getTeaRes()
    this.getTextbook()
  },
  components: {
    ResourcePreview
  },
  computed: {
    ...mapGetters({'account': 'user/user'}),
  },
  methods: {
    fileIcon,
    formatSize,
    handleCurrentChange1(val) {
      this.pn1 = val
      this.getRes()
    },
    handleCurrentChange(val) {
      this.pn = val
      this.getTeaRes()
    },
    clickTeachType(item){
      this.teachType = item.type
      this.pn = 1
      this.getTeaRes()
    },
    look() {
      this.teachFlag = !this.teachFlag
    },
    preview(item) {
      let imgList = []
      let initialIndex = 0
      if (fileType(item.location) == "image") {
        let img = {
          url: item.location,
          name: item.title
        }
        imgList.push(img)
        this.$viewImage({
          zIndex: 1, // 图片预览的z-index值 一般情况下不需要传
          initialIndex: initialIndex, // 初始化展示图片的序号 默认为0
          imgList: imgList, //图片列表 name可选 url必选
          onDownload: this.download
        });
      } else {
        this.currentFile = {
          filePath: item.location,
          fileName: item.title,
        };
        this.isResourcePriviewVisible = true;
      }
    },
    download(item) {
      let obs = new Obs(setObsConfig({ uptokenHost: API_HOST, authorization: this.account.token }));
      let ext = item.location.substring(item.location.lastIndexOf('.') + 1).toLowerCase()
      obs.download(getFullPath(item.location), item.title + '.' + ext);
    },
    downloadFile() {
      window.open(`${COURSE_API_HOST}/teachingResources/download?textbookId=${this.textbook.textbookId}&timestamp=${this.account.token}`)
    },
    clickTextbook(item, type) {
      if (type == 1) {
        this.textbook = item
        this.type = null
      } else {
        this.type = item.type
      }
      this.pn1 = 1
      this.getRes()
    },
    getTextbook() {
      let data = {
        ocId: this.ocId
      }
      let self = this
      getTextbookList(data).then(res => {
        this.textbookList = res.filter(item => {
          return item.chosen == 1
        })

        let list = this.textbookList.filter(item => {
          return self.textbookId == item.textbookId
        })
        this.textbook = list[0]
        this.pn1 = 1
        this.getRes()
      })
    },
    getRes() {
      let data = {
        textbookId: this.textbook.textbookId,
        type: this.type,
        pn: this.pn1,
        ps: 10
      }
      teachingResources(data).then(res => {
        this.textbookResList = res.result.list
        this.total1 = res.result.total
        this.loading = false
      })
    },
    getTeaRes() {
      let data = {
        type: this.teachType,
        pn: this.pn,
        ps: 10
      }
      teaResPublic(data).then(res => {
        this.resList = res.result.list
        this.total = res.result.total
      })
    },
    close() {
      window.close()
    }
  }
}
</script>

<style lang="scss" scoped>
.title {
  font-size: 18px;
  font-weight: bold;
}
::v-deep.course-file {
  .ul-page__body-content {
    width: 980px !important;
  }
  .body-content {
    margin: 20px auto;
    padding: 20px;
    .info {
      padding: 20px;
      background: #f3f3f3;
      color: #969696;
    }
    .screen {
      margin-top: 10px;
      padding: 20px;
      background: #f3f3f3;
      .textbookList {
        margin-bottom: 20px;
      }
      &>div {
        display: flex;
        &>div>span {
          cursor: pointer;
          display: inline-block;
          padding: 0 15px;
          margin: 0 10px;
          border: 1px solid #d1d1d1;
          border-radius: 40px;
        }
        .tit {
          font-weight: bold;
        }
      }
    }
    .common-res {
      margin-top: 20px;
      border: 1px solid #d1d1d1;
      border-bottom: none;
      .top {
        padding: 15px 30px;
        border-bottom: 1px solid #d1d1d1;
        background: #f2f2f2;
        display: flex;
        justify-content: space-between;
        font-weight: bold;
        .look {
          color: #56b5f5;
          cursor: pointer;
        }
      }
    }
    .textbook {
      margin-top: 20px;
      .top {
        display: flex;
        justify-content: space-between;
        border-bottom: 1px solid #d1d1d1;
        padding-bottom: 20px;
        .name {
          font-weight: bold;
          font-size: 22px;
        }
      }
    }
    .location {
      display: flex;
      align-items: center;
      line-height: 30px;
      cursor: pointer;
      i {
        font-size: 24px;
        margin-right: 20px;
      }
    }
  }
}
.activate {
  color: #ea5947;
}
.pagination {
  margin-top: 10px;
  text-align: center;
}
</style>